import React, { Component } from 'react';
import { getIcon, isEmpty } from '../../Common/Common';
import temp from '../../../Images/Daikin_Images/icon/temp.png';

export default class Display_Group_Cell_Option extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
		let group_info = this.props.group_info;

		let temp_string = '';
		let value_string = '';

		if (group_info.hasOwnProperty('temp_targ')) {
			let temp_targ_info = window.app.state.point_list[group_info.temp_targ];
			if (!isEmpty(temp_targ_info)) {
				if (temp_targ_info.comm_stat) { //if there is no communication error for management point
					if (temp_targ_info.type == 'Ac') {
						temp_string = temp_targ_info.temp + this.props.receiver.getString('DEG'); //temperature
					}
					else if (temp_targ_info.type == 'Value') {
						temp_string = temp_targ_info.av + this.props.receiver.getString('DEG'); //av
					}
				}
			}
		}

		if (group_info.hasOwnProperty('value_targ')) {
			let value_targ_info = window.app.state.point_list[group_info.value_targ];
			if (!isEmpty(value_targ_info)) {
				if (value_targ_info.comm_stat) { //if there is no communication error for management point
					let unit = '';
					if (value_targ_info.unit != null) unit = value_targ_info.unit;
					value_string = value_targ_info.av + this.props.receiver.getString(unit);
				}
			}
		}

		let temp_img_width = (0.133) * this.props.cell_width;
		let font_size = (0.133) * this.props.cell_width;

		//this.handleRetrieveValues();

		return (
			<div style={{ display: 'inline-block', verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap' }}>
				<div style={{ display: temp_string == '' ? 'none' : 'block', whiteSpace: 'nowrap' }}>
					<div style={{ display: 'inline-block' }}>
						<img src={temp} style={{ width: temp_img_width }} />
					</div>
					<div style={{ display: 'inline-block', verticalAlign: 'top', whiteSpace: 'nowrap' }}>
						<span style={{ fontSize: font_size }}>{temp_string}</span>
					</div>
				</div>
				<div style={{ display: value_string == '' ? 'none' : 'block', marginTop: -5, whiteSpace: 'nowrap' }}>
					<span style={{ fontSize: font_size, whiteSpace: 'nowrap' }}>{value_string}</span>
				</div>
			</div>
		)
	}
}